import { render, staticRenderFns } from "./WatchInGrid.vue?vue&type=template&id=84c5f13c&scoped=true&"
import script from "./WatchInGrid.vue?vue&type=script&lang=js&"
export * from "./WatchInGrid.vue?vue&type=script&lang=js&"
import style0 from "./WatchInGrid.vue?vue&type=style&index=0&id=84c5f13c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c5f13c",
  null
  
)

export default component.exports